import { getUrlForSidebarAppId } from '../layout';
import { LandingPage } from '../pages';
import { useAnnotationToolAllowedApps } from './useAnnotationToolAllowedApps';
import { useAnnotationToolSidebarConfig } from './useAnnotationToolSidebarConfig';

/**
 * Internal Platform-specific container for LandingPage.
 * Redirects to the first app the user has access to based on their roles.
 * Shows a no-access message if the user has no authorized roles.
 */
export const AnnotationToolLandingPage = () => {
  const sidebarConfig = useAnnotationToolSidebarConfig();
  const allowedApps = useAnnotationToolAllowedApps();
  return (
    <LandingPage
      apps={allowedApps}
      getUrl={(appId) => getUrlForSidebarAppId(sidebarConfig, appId)}
    />
  );
};
